// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Icon__Jsx3 = require("../../../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var TailwindMerge = require("tailwind-merge");
var JsxRuntime = require("react/jsx-runtime");

function Alert$Success(props) {
  var __className = props.className;
  var className = __className !== undefined ? __className : "";
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsx("div", {
                                  children: JsxRuntime.jsx(Icon__Jsx3.make, {
                                        icon: "OkCircled"
                                      }),
                                  className: "w-4 h-4 text-green-400"
                                }),
                            className: "flex-shrink-0"
                          }),
                      JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsx("p", {
                                  children: props.title,
                                  className: "font-medium text-green-800"
                                }),
                            className: "ml-3"
                          })
                    ],
                    className: "flex"
                  }),
              className: TailwindMerge.twMerge([
                    "rounded-md bg-green-50 p-4",
                    className
                  ])
            });
}

var Success = {
  make: Alert$Success
};

function Alert$Error(props) {
  var __className = props.className;
  var className = __className !== undefined ? __className : "";
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsx("div", {
                                  children: JsxRuntime.jsx(Icon__Jsx3.make, {
                                        icon: "CancelCircled"
                                      }),
                                  className: "w-4 h-4 text-red-400"
                                }),
                            className: "flex-shrink-0"
                          }),
                      JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsx("p", {
                                  children: props.title,
                                  className: "font-medium text-red-700"
                                }),
                            className: "ml-3"
                          })
                    ],
                    className: "flex"
                  }),
              className: TailwindMerge.twMerge([
                    "rounded-md bg-red-50 p-4",
                    className
                  ])
            });
}

var $$Error = {
  make: Alert$Error
};

exports.Success = Success;
exports.$$Error = $$Error;
/* Icon__Jsx3 Not a pure module */
